import React from "react";
import { Link } from "react-router-dom";
import { Star, ShoppingBag } from "lucide-react";
import { useStore } from "../../context/StoreContext";
import { t } from "../../lib/i18n";
import { toast } from "sonner";

export const ProductCard = ({ product }) => {
  const { lang, addToCart, formatPrice } = useStore();
  const name = lang === "ar" ? product.name_ar : product.name_en;
  return (
    <div className="product-card bg-white border border-[#e8ddc9] rounded-2xl overflow-hidden group" data-testid={`product-card-${product.id}`}>
      <Link to={`/product/${product.id}`} className="block relative aspect-[4/5] overflow-hidden bg-[#f5efe4]">
        <img src={product.image} alt={name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" loading="lazy" />
        {product.featured && (
          <span className="absolute top-3 start-3 bg-[color:var(--thiqa-gold)] text-black text-[10px] font-bold uppercase px-2.5 py-1 rounded-full tracking-wider">
            {lang === "ar" ? "مميّز" : "Featured"}
          </span>
        )}
      </Link>
      <div className="p-4 md:p-5">
        <Link to={`/product/${product.id}`}>
          <h3 className="text-sm md:text-base font-semibold text-gray-900 hover:text-[color:var(--thiqa-primary)] line-clamp-2 min-h-[3rem] transition-colors">{name}</h3>
        </Link>
        <div className="flex items-center gap-1 mt-2">
          {[1, 2, 3, 4, 5].map((n) => (
            <Star key={n} size={14} className={n <= Math.round(product.rating_avg || 0) ? "star-fill fill-current" : "star-empty"} />
          ))}
          <span className="text-xs text-gray-500 ms-1">({product.rating_count || 0})</span>
        </div>
        <div className="flex items-center justify-between mt-3">
          <span className="text-lg font-bold" style={{ color: "var(--thiqa-primary)" }}>{formatPrice(product.price_usd)}</span>
          <button
            data-testid={`add-to-cart-${product.id}`}
            onClick={(e) => {
              e.preventDefault();
              addToCart(product);
              toast.success(lang === "ar" ? "أُضيف إلى السلة" : "Added to cart");
            }}
            className="btn-primary-thiqa rounded-full p-2.5 shadow hover:shadow-md"
            aria-label={t(lang, "add_to_cart")}
          >
            <ShoppingBag size={16} />
          </button>
        </div>
      </div>
    </div>
  );
};
